/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', () => {
  const content_tabs = document.querySelectorAll('.content-tab__container');
  if(content_tabs) {
    content_tabs.forEach((section) => {
      const tabs = section.querySelectorAll('.tab');
      const contents = section.querySelectorAll('.tab-content');
    
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          if(!tab.classList.contains('disabled')) {
            tabs.forEach(t => t.classList.remove('active'));
            contents.forEach(c => c.classList.add('hide'));
      
            tab.classList.add('active');
            section.querySelector(`#${tab.dataset.tab}`).classList.remove('hide');
          }
        });
      });
    })
  }

  const accordions = document.querySelectorAll('details');
  accordions.forEach(detail => {
    detail.addEventListener('toggle', () => {
      if (detail.open) {
        accordions.forEach(other => {
          if (other !== detail && other.open) {
            other.open = false;
          }
        });
      }
    });
  });
});